export enum StepStatusEnum {
  Waiting = 'loop',
  Success = 'done',
  Skiped = 'block' ,
  Error = 'cancel',
}
